import { useQuery } from "@tanstack/react-query";

import { ListPartnersQueryFilters, UseListPartnersQueryOptions } from "./types";
import { getPartnersService } from "./service";

export const listPartnersQueryKey = ["v1/partner_admin"];

export function useListPartnersQuery(
  filters?: ListPartnersQueryFilters,
  options?: UseListPartnersQueryOptions
) {
  const queryKey = listPartnersQueryKey.concat(JSON.stringify(filters ?? {}));

  return useQuery({
    queryKey,
    queryFn: async () => getPartnersService(filters),
    ...options,
  });
}
